<template>
  <div class="hc-detail-grid" :class="{ 'hc-detail-grid--single': single }">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ProfileDetailGrid',
  props: {
    single: { type: Boolean, default: false },
  },
};
</script>
